import styled, { css } from "styled-components"
import {
  background,
  border,
  color, flex,
  flexbox,
  layout,
  opacity,
  position,
  size,
  space,
  textAlign,
  textStyle,
  margin
} from "styled-system";

export const common = [
  flex,
  background,
  space,
  flexbox,
  border,
  color,
  position,
  layout,
  size,
  opacity,
  textAlign,
  textStyle,
  margin
]

export const blockPaddingTop = css`
  padding-top: 5rem;
`

export const blockPaddingBottom = css`
  padding-bottom: 5rem;
`

export const blockPadding = css`
  ${blockPaddingTop};
  ${blockPaddingBottom};
`

export const blockStyles = css`
  width: 100%;
  margin: 5rem auto;
`

export const Box = styled.div`
  ${common};
  background: ${({ theme, background }) => theme.color[background] ?? background};
  position: relative;
`

export const Column = styled.div`
  ${common};
  display: flex;
  flex-direction: ${({ flexDirection = "column" }) => flexDirection};
`

export const Row = styled.div`
  ${common};
  display: flex;
  background: ${({ theme, background }) => theme.color[background] ?? background};
`

export const Grid = styled.div`
  ${common};
  display: grid;
`

export const Absolute = styled(Box)`
  ${common};
  position: absolute !important;
`
